import { css } from "@stubhub/broadway-foundation/css";

export const shimmerBase = {
  backgroundImage:
    "[linear-gradient(135deg,var(--bway-colors-bg-surface-stronger) 25%,var(--bway-colors-bg-surface-strong) 50%,var(--bway-colors-bg-surface-stronger) 75%)]",
  backgroundSize: "[200% 200%]",
  animationName: "[shimmer]",
  animationDuration: "[1.5s]",
  animationTimingFunction: "[linear]",
  animationIterationCount: "[infinite]",
  borderStartStartRadius: "primitives.50",
  borderStartEndRadius: "primitives.50",
  borderEndStartRadius: "primitives.50",
  borderEndEndRadius: "primitives.50",
} as const;

export const skeletonContainer = css({
  paddingBlock: "primitives.200",
  paddingInline: "primitives.0",
  width: "full",
  overflowX: "hidden",
  overflowY: "hidden",
});

export const skeletonTitle = css({
  ...shimmerBase,
  height: "primitives.300",
  width: "[200px]",
  marginBlockEnd: "primitives.200",
});

export const skeletonCardsRow = css({
  display: "flex",
  // Mobile (phone): 16px gap — matches Small4x3 carousel gap
  columnGap: "primitives.200",
  rowGap: "primitives.200",
  // Desktop (tablet and above): 32px gap — matches MediumCarouselImage carousel gap
  tablet: {
    columnGap: "primitives.400",
    rowGap: "primitives.400",
  },
});

export const skeletonCard = css({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: "auto",
  // Match HoverCardWrapper padding: spacing(2) = 8px = primitives.100
  paddingBlockStart: "primitives.100",
  paddingBlockEnd: "primitives.100",
  paddingInlineStart: "primitives.100",
  paddingInlineEnd: "primitives.100",
  // Match HoverCardWrapper border-radius: spacing(3) = 12px = primitives.150
  borderStartStartRadius: "primitives.150",
  borderStartEndRadius: "primitives.150",
  borderEndStartRadius: "primitives.150",
  borderEndEndRadius: "primitives.150",
  // Mobile (phone): 156px — matches Small4x3 image width
  width: "[156px]",
  // Desktop (tablet and above): 276px — matches MediumCarouselImage width
  tablet: {
    width: "[276px]",
  },
});

export const skeletonCardMedium4x3 = css({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: "auto",
  // Match HoverCardWrapper padding: spacing(2) = 8px = primitives.100
  paddingBlockStart: "primitives.100",
  paddingBlockEnd: "primitives.100",
  paddingInlineStart: "primitives.100",
  paddingInlineEnd: "primitives.100",
  // Match HoverCardWrapper border-radius: spacing(3) = 12px = primitives.150
  borderStartStartRadius: "primitives.150",
  borderStartEndRadius: "primitives.150",
  borderEndStartRadius: "primitives.150",
  borderEndEndRadius: "primitives.150",
  // Medium4x3: 180px on all viewports (reduced card size, mobile client apps)
  width: "[180px]",
});

export const skeletonCardImage = css({
  ...shimmerBase,
  borderStartStartRadius: "primitives.100",
  borderStartEndRadius: "primitives.100",
  borderEndStartRadius: "primitives.100",
  borderEndEndRadius: "primitives.100",
  width: "full",
  marginBlockEnd: "primitives.100",
  // Mobile (phone): 117px — matches Small4x3 image height
  height: "[117px]",
  // Desktop (tablet and above): 198px — matches MediumCarouselImage height
  tablet: {
    height: "[198px]",
  },
});

export const skeletonCardImageMedium4x3 = css({
  ...shimmerBase,
  borderStartStartRadius: "primitives.100",
  borderStartEndRadius: "primitives.100",
  borderEndStartRadius: "primitives.100",
  borderEndEndRadius: "primitives.100",
  width: "full",
  marginBlockEnd: "primitives.100",
  // Medium4x3: 134px on all viewports (reduced card size, mobile client apps)
  height: "[134px]",
});

export const skeletonCardsRowLegacy = css({
  display: "flex",
  columnGap: "primitives.200",
  rowGap: "primitives.200",
});

export const skeletonCardLegacy = css({
  flexGrow: 0,
  flexShrink: 0,
  flexBasis: "auto",
  width: "[200px]",
});

export const skeletonCardImageLegacy = css({
  ...shimmerBase,
  borderStartStartRadius: "primitives.100",
  borderStartEndRadius: "primitives.100",
  borderEndStartRadius: "primitives.100",
  borderEndEndRadius: "primitives.100",
  height: "[133px]",
  width: "full",
  marginBlockEnd: "primitives.100",
});

export const skeletonCardLine = css({
  ...shimmerBase,
  height: "primitives.175",
  width: "full",
  marginBlockEnd: "primitives.75",
});
